import { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useSearchParams } from "react-router-dom";
import { api, errorText, money } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthLayout } from "@/components/brand/AuthLayout";
import { FormError, FormSuccess } from "@/components/brand/Field";

export default function ActionScreen() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const loc = useLocation();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");
  const [link, setLink] = useState(null);
  useEffect(() => {
    if (!user) return;
    api.get(`/alerts/action/${params.get("token")}`).then((r) => setD(r.data)).catch((e) => setErr(errorText(e)));
  }, [user, params]);
  if (user === null) return null;
  if (user === false) return <Navigate to="/signin" replace state={{ from: loc.pathname + loc.search }} />;
  const act = async (fn, ok) => { setErr(""); try { await fn(); setMsg(ok); } catch (e) { setErr(errorText(e)); } };
  return (
    <AuthLayout title={d ? d.item.vendor : "Opening…"} subtitle={d?.note} footer={<Link className="ts-link" to="/app" data-testid="act-back">Back to your workspace</Link>}>
      <FormError message={err} testId="act-error" /><FormSuccess message={msg} testId="act-success" />
      {d && (
        <div className="text-sm" data-testid="action-screen" data-intent={d.intent}>
          <p className="num">{d.item.amount_cents != null ? `${money(d.item.amount_cents, d.item.currency)} ${d.item.frequency}` : ""}{d.item.renewal_date && <> · renews {d.item.renewal_date}{d.days_to_renewal != null && ` (in ${d.days_to_renewal} days)`}</>}</p>
          <p className="text-xs mt-2 p-2 rounded num" style={{ background: "var(--paper)" }}>{d.item.source?.filename}: "{d.item.source?.excerpt}"</p>
          <div className="flex flex-col gap-2 mt-5">
            <button className="ts-btn ts-btn-ghost" data-testid="act-cancel-link" onClick={() => act(async () => { const r = await api.get(`/cancel-link/${d.item.id}`); setLink(r.data); }, "")}>Open the vendor's cancellation page</button>
            {link && <p className="text-xs" data-testid="act-link-note">{link.url && <a className="ts-link" href={link.url} target="_blank" rel="noreferrer">{link.vendor} site</a>} {link.note}</p>}
            {d.plan === "core" && <button className="ts-btn ts-btn-ghost" data-testid="act-draft" onClick={() => act(() => api.post("/cancellations/draft", { item_ids: [d.item.id] }), "Draft created under Subscriptions › Cancellation requests. Nothing was sent.")}>Draft a cancellation request (you confirm before it's queued)</button>}
            <button className="ts-btn ts-btn-ghost" data-testid="act-mute" onClick={() => act(() => api.post(`/subscriptions/${d.item.id}/mute`, { scope: "vendor" }), "We'll stop flagging this vendor.")}>Stop alerts for this vendor</button>
            <Link to="/app/subscriptions" className="ts-btn ts-btn-primary" data-testid="act-open">Open in Subscriptions</Link>
          </div>
        </div>
      )}
    </AuthLayout>
  );
}
